import axios from 'axios';

import { getApiEndPoint } from '../../../helpers/apibase';
import { mapServerError } from '../../../services/utils/serverErrorMapper';

const baseURL = getApiEndPoint();

const whitelabelApi = axios.create({
  baseURL: `${baseURL}/api/v1.0`,
  withCredentials: true,
});

export interface WhitelabelGenericConfig {
  appName: string;
  bundleId: string;
}

export interface BuildRequest {
  buildType: 'screenshot' | 'enterprise' | 'production';
  branch: string;
}

export interface WhiteLabelAppStoreConfig {
  [key: string]: any;
}

export interface WhiteLabelPlayStoreConfig {
  [key: string]: any;
}

export interface WhiteLabelConfig {
  AppStoreName?: string;
  AppNameId?: string;
  [key: string]: any;
}

const getWhiteLabelConfig = async (whiteLabelId: string): Promise<WhiteLabelConfig> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/name/${whiteLabelId}`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const getWhitelabelGenericConfig = async (
  whiteLabelId: string
): Promise<WhitelabelGenericConfig> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/${whiteLabelId}/general`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const startAndroidBuild = async (
  whiteLabelId: string,
  buildRequest: BuildRequest
): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelbuilds/${whiteLabelId}/android`, buildRequest);
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const startIosBuild = async (whiteLabelId: string, buildRequest: BuildRequest): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelbuilds/${whiteLabelId}/ios`, null, {
      params: buildRequest,
    });
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const getWhitelabelAppStoreConfig = async (appId: string): Promise<WhiteLabelAppStoreConfig> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/${appId}/appstore`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const updateWhiteLabelAppStoreConfig = async (
  appId: string,
  config: WhiteLabelAppStoreConfig
): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelconfig/${appId}/appstore`, config);
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const getWhiteLabelPlayStoreConfig = async (appId: string): Promise<WhiteLabelPlayStoreConfig> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/${appId}/playstore`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

const updateWhiteLabelPlayStoreConfig = async (
  appId: string,
  config: WhiteLabelPlayStoreConfig
): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelconfig/${appId}/playstore`, config);
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

export const whitelabelService = {
  getWhiteLabelConfig,
  getWhitelabelGenericConfig,
  startAndroidBuild,
  startIosBuild,
  getWhitelabelAppStoreConfig,
  updateWhiteLabelAppStoreConfig,
  getWhiteLabelPlayStoreConfig,
  updateWhiteLabelPlayStoreConfig,
};
